import { createFileRoute } from '@tanstack/react-router';
import { YieldReport } from '../../../features/reports/screens/YieldReport';

/** Owned by G25. Report #4 (BUILD_SPEC.md §9.5) — yield by stage/run vs recipe. */
export const Route = createFileRoute('/_authenticated/reports/yield')({
  component: YieldReport,
});
